// extracted by mini-css-extract-plugin
export var attachmentContainer = "_k9-0";
export var fileList = "_k9-2";
export var removeFileButton = "_k9-1";